import { Component, Input, OnInit } from '@angular/core';
import { TranslocoDatePipe } from '@jsverse/transloco-locale';
import { ListPageColumnComponent } from 'design-system';

// Data e ora del task nell'ora locale, come nel dettaglio: la colonna data della tabella le formatta in UTC
@Component({
  selector: 'task-date-cell',
  imports: [TranslocoDatePipe],
  template: `
    @if (date) {
      {{ date | translocoDate: { day: '2-digit', month: '2-digit', year: 'numeric' } }}
      {{ date | translocoDate: { hour: '2-digit', minute: '2-digit' } }}
    }
  `,
})
export class TaskDateCell extends ListPageColumnComponent implements OnInit {
  @Input() date: Date | string | null = null;

  ngOnInit(): void {
    if (this.itemData && this.infoColumn) {
      this.date = this.itemData[this.infoColumn.columnNameDef];
    }
  }
}
